import { TaskModule } from 'src/app/task/task.module';
import { EventComponent } from './event.component';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { EventTaskListComponent } from './event-task-list/event-task-list.component';
import { EventListComponent } from './event-list/event-list.component';
import { EventSchedulerComponent } from './event-scheduler/event-scheduler.component';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { EventEditAppointmentComponent } from './event-edit-appointment/event-edit-appointment.component';
import { EventCancelAppointmentComponent } from './event-cancel-appointment/event-cancel-appointment.component';
import { DirectorySearchChannelsModule } from '../shared/directory-search/directory-search-channels/directory-search-channels.module';
import { TaskAddModule } from '../shared/task-add/task-add.module';

@NgModule({
  declarations: [
    EventComponent,
    EventTaskListComponent,
    EventListComponent,
    EventSchedulerComponent,
    EventEditAppointmentComponent,
    EventCancelAppointmentComponent
  ],
  imports: [
    SharedModule,
    TaskModule,
    SchedulerModule,
    DirectorySearchChannelsModule,
    TaskAddModule
  ],
  exports:
    [
      EventComponent,
      EventListComponent,
      EventEditAppointmentComponent
    ]
})
export class EventModule { }
